import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import * as mutation from '@/store/mutation.types'
import { GET_MESSAGE_CONTACTS_URL } from '@/constants/ApiConstants';

const state = {
  contactsList: [],
  conversationsList: [],
  subscribedConversationsList: [],
  hasClickedOnContact: false,
  scrollDirection: ''
 };

const getters = {
  getContactsList: state => {
    return state.contactsList;
  },
  getConversationsList: state => {
    return state.conversationsList
  },
  getSubscribedConversationsList: state => {
    return state.subscribedConversationsList
  },
  getHasClickedOnContact: state => {
    return state.hasClickedOnContact
  },
  getScrollDirection: state => state.scrollDirection
}

const mutations = {
  [mutation.SET_CONTACTS_LIST] (state, contactsList) {
    state.contactsList = contactsList;
  },
  [mutation.SET_CONVERSATIONS_LIST] (state, conversationsList) {
    state.conversationsList = conversationsList;
  },
  [mutation.SET_SUBSCRIBED_CONVERSATIONS_LIST] (state, subscribedConversationsList) {
    state.subscribedConversationsList = subscribedConversationsList;
  },
  [mutation.SET_CLICKED_ON_CONTACT] (state, actionPayload) {
    state.hasClickedOnContact = actionPayload;
  },
  [mutation.SET_SCROLL_DIRECTION] (state, actionPayload) {
    state.scrollDirection = actionPayload;
  }
};

const actions = {
  [action.GET_MESSAGE_CONTACTS]() {
    return ApiService.get(GET_MESSAGE_CONTACTS_URL);
  },
  [action.SET_SUBSCRIBED_CONVERSATIONS_LIST] ({ commit }, data) {
    commit(mutation.SET_SUBSCRIBED_CONVERSATIONS_LIST, data)
  },
  [action.GET_CLICKED_ON_CONTACT] ({ commit }, data) {
    commit(mutation.SET_CLICKED_ON_CONTACT, data)
  },
  [action.GET_SCROLL_DIRECTION] ({ commit }, data) {
    commit(mutation.SET_SCROLL_DIRECTION, data)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
